import { createApiQueryHook, type IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, type RelationalValue } from "../../utils/filters";
import type { IGroupMessageResource } from "../types/IGroupMessageResource";

export interface IGroupMessageQueryParameters {
    groupMessage?: RelationalValue<IGroupMessageResource>;
}

export type IGroupMessageQueryResult = IGroupMessageResource;

export const groupMessageQuery: IApiQueryFunction<IGroupMessageQueryParameters> = ({ groupMessage }) => {
    if (!groupMessage) {
        return;
    }

    return {
        method: "GET",
        url: `/group_messages/${mapRelationalValue(groupMessage)}`,
    };
};

export const useGroupMessageQuery = createApiQueryHook<IGroupMessageQueryParameters, IGroupMessageQueryResult>(
    groupMessageQuery,
);
